import styled from "styled-components"

export const Main = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: ${props => props.theme.colors?.host_background};
  color: ${props => props.theme.colors?.host_text_primary};
  font-size: 20px;
  display: grid;
  align-items: center;
  justify-content: center;
  background-image: url(${props =>
    props.backgroundImage
      ? props.backgroundImage
      : props.theme.images?.host_default_background_image});
  background-size: cover; /* or 100% 100% */
  background-position: center;
  background-repeat: no-repeat;
  padding: 0px 100px 150px 100px;
  @media (max-height: 800px) {
    padding: 0px 100px 200px 100px;
  }
`

export const CenterPiece = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors?.host_centerpiece_background};
  min-width: 400px;
  max-width: 1000px;
  max-height: calc(100vh - 100px);
  border: 1px solid ${props => props.theme.colors?.host_centerpiece_border};
  border-radius: 10px;
  padding: 20px 20px 20px 20px;
  align-items: center;
  overflow: auto;

  div {
    margin: 5px;
  }

  h1 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  h2 {
    margin-top: 0px;
  }
`

export const Footer = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  padding: 0px 20px 10px 20px;
  display: grid;
  grid-template-columns: 150px 1fr 150px;
  align-items: end;
  justify-items: center;
  column-gap: 10px;
  min-height: 70px;
`
export const Button = styled.button`
  min-height: 40px;
  background-color: ${props => props.theme.colors?.host_button_background};
  color: ${props => props.theme.colors?.host_button_text};
  padding: 0px 10px;
  font-size: 16px;
  border: 1px solid ${props => props.theme.colors?.host_button_border};
  border-radius: 5px;

  cursor: pointer;
  // text-transform: uppercase;

  :disabled {
    background-color: lightgrey;
    color: grey;
    border-color: lightgrey;
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const Previous = styled(Button)`
  margin-right: auto;
  grid-column: 1/2;
  padding: 5px 10px;
`

/** replaced by NextButton */
// export const Next = styled(Button)`
//   margin-left: auto;
//   grid-column: 3/4;
// `

export const FooterCenter = styled.div`
  grid-column: 3/4;
`
export const OverviewItemImage = styled.img`
  width: 130px;
  height: auto;
  background-color:white;
  padding: 15px;
  border-radius: 10px;
`
export const ButtonA = styled.a`
  width:100%;
  padding:20px 0;
  box-sizing: border-box;
  border-bottom: 1px solid rgb(233, 233, 233);
  color:#031037;
  background-color:white;
  font-weight: bold;
  position: relative;
  text-decoration: none;
  &:hover {
  background-color: rgb(242, 242, 242);
  }
  &:first-of-type{
  border-top: 1px solid rgb(233, 233, 233);
}
`

export const SpanButton = styled.span`
position: absolute;
  right: 10px;
  margin-top: -4px;
  padding: 5px 9px;
  color:#031037;
  border-radius: 50%;
  background-color: #ffbe32;
`
export const MainOverview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  flex-wrap: wrap; 
  width: 100%;
  margin:auto;
  padding-bottom:15px;
  justify-content: center;
  @media only screen and (min-width: 800px) { 
    width:500px;
  }
  @media only screen and (max-width: 600px) { 
    width:100%;
  }
`
export const ReturnButton = styled.a`
  text-decoration: none;
  background-color: #f2eff0;
  border-radius: 10px;
  padding:10px 20px;
  color: #031037;
  font-weight: bold;
  display: inline-block;
`
export const DivContainer = styled.div`
padding-top: 20px;
display:flex;
flex-direction:column;
align-items: center;
`
export const POverview = styled.p`
font-size: 1rem;
`
export const H2Overview = styled.h2`
font-size: 2rem;
margin:0;
padding:0;
`

export const LabelLanguage = styled.span`
font-size: 12px;
background-color: #F0F0F0;
border: 1px solid #F0F0F0;
padding:2px 3px;
margin-left:4px;
border-radius: 4px;
text-transform: uppercase;
`